export const USER = "USER";
export const userAction = (data) => {
    return {
        type: "USER",
        payload:data
    }
}